import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isBannersModalVisible: false,
  isAnnouncementsModalVisible: false,
  bannersList: [],
  announcementsList: [],
  loading: false,
  error: false,
  errorMessage: '',
};

const bannersSlice = createSlice({
  name: 'banners',
  initialState,
  reducers: {
    setLoading(state, action) {
      const { isLoading, willClearError } = action.payload;

      if (willClearError) {
        state.error = false;
        state.errorMessage = '';
      }
      state.loading = isLoading;
    },
    setError(state, action) {
      state.loading = false;
      state.error = true;
      state.errorMessage = action.payload;
    },
    setBanners(state, action) {
      state.bannersList = action.payload;
    },
    setAnnouncements(state, action) {
      state.announcementsList = action.payload;
    },
    setBannerVisible(state, action) {
      state.isBannersModalVisible = action.payload;
    },
    setAnnouncementVisible(state, action) {
      state.isAnnouncementsModalVisible = action.payload;
    },
    resetListings: (state) => initialState,
    logout: (state) => initialState,
  },
});

export const bannersActions = bannersSlice.actions;
export default bannersSlice;
